export default "__VITE_ASSET__B2kAQ3Qt__"